import React, { createContext, useContext, useState, useEffect } from 'react';

// Each theme only swaps the primary "brand" hue (via CSS variables defined
// in index.css). gold and bloom stay constant across every theme since they
// carry fixed meaning - achievement and gentle comfort - not just decoration.
const THEMES = {
  teal: { name: 'טורקיז ים', preview: '#3C8175' },
  blue: { name: 'כחול שקט', preview: '#3B82F6' },
  purple: { name: 'סגול מרגיע', preview: '#8B5CF6' },
  green: { name: 'ירוק טבע', preview: '#10B981' },
  orange: { name: 'כתום חמים', preview: '#F97316' },
};

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [themeName, setThemeName] = useState(() =>
    localStorage.getItem('app_theme') || 'teal'
  );

  // Apply the theme to <html> so every bg-brand-*/text-brand-* class
  // in the app (via CSS variables) picks it up immediately, including
  // on first load before any click happens.
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', themeName);
  }, [themeName]);

  const setTheme = (name) => {
    setThemeName(name);
    localStorage.setItem('app_theme', name);
  };

  return (
    <ThemeContext.Provider value={{ themeName, setTheme, THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be inside ThemeProvider');
  return ctx;
};

const ThemeSelector = () => {
  const { themeName, setTheme, THEMES: themes } = useTheme();

  return (
    <div className="bg-white rounded-xl p-4 border border-stone-200 shadow-sm">
      <p className="text-sm font-bold text-stone-800 mb-3">🎨 ערכת צבעים</p>
      <div className="grid grid-cols-5 gap-2">
        {Object.entries(themes).map(([key, t]) => (
          <button
            key={key}
            onClick={() => setTheme(key)}
            className={`flex flex-col items-center gap-1 p-2 rounded-xl transition-all ${
              themeName === key ? 'ring-2 ring-offset-2 ring-stone-400 scale-110' : 'hover:scale-105'
            }`}
          >
            <div
              className="w-10 h-10 rounded-full shadow-md"
              style={{ backgroundColor: t.preview }}
            />
            <span className="text-xs text-stone-600 text-center leading-tight">{t.name.split(' ')[0]}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeSelector;
